import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { ShieldCheck, CheckCircle2, Clock, Circle } from "lucide-react";
import { toast } from "sonner";

const STATUSES = ["implemented", "in_progress", "not_started"];
const STATUS_COLORS = { implemented: "#10B981", in_progress: "#EAB308", not_started: "#475569" };

export default function Frameworks() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/frameworks").then((r) => setItems(r.data.frameworks));
  useEffect(() => { load(); }, []);

  const setControl = async (fw_id, control, status) => {
    await api.post("/frameworks/control", { framework_id: fw_id, control_name: control, status });
    toast.success(`${control} → ${status}`);
    load();
  };

  return (
    <div className="p-8 space-y-6" data-testid="frameworks-page">
      <div className="border-b border-[var(--border)] pb-5">
        <div className="label-mono mb-2">CUMPLIMIENTO NORMATIVO</div>
        <h1 className="font-display font-black text-4xl tracking-tight">Compliance</h1>
        <p className="text-sm text-[var(--text-dim)] mt-1">
          OWASP LLM · NIST AI RMF · ISO 42001 · ISO 27001 · CIS · GDPR · EU AI Act.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((f) => (
          <div key={f.id} className="border border-[var(--border)] bg-[var(--surface)] p-5" data-testid={`fw-${f.id}`}>
            <div className="flex items-start justify-between mb-4">
              <div>
                <div className="label-mono mb-1">{f.category}</div>
                <div className="font-display font-bold text-lg">{f.name}</div>
              </div>
              <div className="text-right">
                <div className="label-mono">COBERTURA</div>
                <div className="font-display font-black text-2xl text-[var(--accent)]">{f.coverage}%</div>
              </div>
            </div>
            {/* progress */}
            <div className="h-1 bg-[var(--bg)] mb-4">
              <div className="h-1 bg-[var(--accent)]" style={{ width: `${f.coverage}%` }} />
            </div>
            <div className="space-y-2">
              {f.controls.map((c) => (
                <div key={c.name} className="flex items-center gap-2" data-testid={`fw-${f.id}-${c.name.replace(/\s/g, "-")}`}>
                  {c.status === "implemented" ? (
                    <CheckCircle2 className="w-3 h-3" style={{ color: STATUS_COLORS[c.status] }} />
                  ) : c.status === "in_progress" ? (
                    <Clock className="w-3 h-3" style={{ color: STATUS_COLORS[c.status] }} />
                  ) : (
                    <Circle className="w-3 h-3" style={{ color: STATUS_COLORS[c.status] }} />
                  )}
                  <span className="text-xs flex-1 text-white">{c.name}</span>
                  <Select value={c.status} onValueChange={(v) => setControl(f.id, c.name, v)}>
                    <SelectTrigger className="w-32 rounded-none bg-[var(--bg)] border-[var(--border)] font-mono text-[10px] h-7">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent className="rounded-none bg-[var(--surface)] border-[var(--border)]">
                      {STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
